import React, { ReactChild } from 'react';
import { SpacingSizes } from '@/utils/constants';
import { MuiContainer } from '@/features/shared/material-ui';
import ContentContainer from '@/features/shared/ContentContainer/ContentContainer';
import { useConditionalContentContainerStyles } from '@/features/PortalNavigation/components/ConditionalContentContainer/ConditionalContentContainer.styles';

export interface ConditionalContentContainerProps {
  hasPortalContainer: boolean;
  containerBackgroundColor: any;
  datalayerVariant: any;
  children: ReactChild;
}

export const ConditionalContentContainer = ({
  hasPortalContainer,
  containerBackgroundColor,
  datalayerVariant,
  children,
}: ConditionalContentContainerProps) => {
  const classes = useConditionalContentContainerStyles();

  return (
    <ContentContainer
      topSpacing={hasPortalContainer ? SpacingSizes.small : SpacingSizes.none}
      bottomSpacing={hasPortalContainer ? SpacingSizes.small : SpacingSizes.none}
      topBackgroundColor={containerBackgroundColor}
      bottomBackgroundColor={containerBackgroundColor}
      datalayerPosition="portal_navigation"
      datalayerVariant={datalayerVariant}
    >
      <MuiContainer className={classes.container}>{children}</MuiContainer>
    </ContentContainer>
  );
};
